import * as React from 'react';
import { colors } from '../../../index';

const IconMessage = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 17 14",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.506 0H1.494C.671 0 0 .677 0 1.509v10.059c0 .829.668 1.509 1.494 1.509h14.012c.82 0 1.494-.675 1.494-1.509V1.508C17 .68 16.332 0 15.506 0zM15.3 1.006L8.532 7.84 1.705 1.006H15.3zM.996 11.36V1.712l4.797 4.803L.996 11.36zm.704.711l4.8-4.848 1.683 1.684a.495.495 0 00.702-.001l1.64-1.656 4.775 4.82H1.7zm14.304-.711L11.23 6.538l4.774-4.82v9.642z",
    fill: "currentColor"
  }));
};

export default IconMessage;